import React from 'react'
import { ReactComponent as LoaderIcon } from 'images/loader.svg';
import clsx from 'clsx';
import styles from './Loader.module.scss'

export default function Loader({ className }: { className?: string }) {
  return (
    <div className={clsx(styles.loader, className)}><LoaderIcon /></div>
  )
}
